import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { API_ROOT } from '../config';
import { Button, Popover, Avatar, Tooltip } from 'antd';
import { BellOutlined, MenuOutlined, UserOutlined } from '@ant-design/icons';
import TopNavigation from './TopNavigation';

import { logoutUser } from '../redux/auth';

const HeaderLayout = () => {
  const [selectedCity, setSelectedCity] = useState(343);
  const [notifications, setNotifications] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleProfileClick = () => {
    navigate('/profile');
  };
  useEffect(() => {
    let isMounted = true;

    const loadNotifications = async (value) => {
      try {
        const notifRes = await fetch(`${API_ROOT}/api/data/darmen`);
        const notifData = await notifRes.json();
        const { notifications } = notifData.data.model[0];

        if (isMounted) {
          setSelectedCity(value);
          setNotifications(notifications);
        }
      } catch (e) {
        if (isMounted) {
          setSelectedCity(value);
          setNotifications([]);
        }
      }
    };

    loadNotifications(selectedCity);

    return () => {
      isMounted = false; // Cleanup on component unmount
    };
  }, [selectedCity]);

  const handleLogout = () => {
    logoutUser(dispatch);
    navigate('/signin'); // Redirect to the sign-in page after logout
  };

  let user = window.localStorage.getItem('user_params');
  if (user) {
    user = JSON.parse(user);
  }

  return (
      <header className="header">
        <div className="logo">
          <Button icon={<MenuOutlined />} className="menuButton">
            Меню
          </Button>
          <img src="./images/gerb.svg" alt="Герб Атырау" width='40px' height='40px'/>
            <h3 className="menuText">Атырауская область</h3>
        </div>
        <TopNavigation {...{ user }} />
        <div className="exit">
          {user && (
              <Tooltip title="Профиль пользователя">
                <Button
                    type="link"
                    onClick={handleProfileClick}
                    style={{ marginRight: 12, display: 'flex', alignItems: 'center', color: 'white' }}
                >
                  <Avatar
                      size="small"
                      icon={<UserOutlined />}
                      style={{ marginRight: 8 }}
                  />
                  {user.username}
                </Button>
              </Tooltip>
          )}
          <Button onClick={handleLogout} style={{ marginRight: 6 }}>
            Выйти
          </Button>
        </div>
      </header>
  );
};

export default HeaderLayout;
